<span class="cursor-pointer" (click)="changeTimerState()">{{getTime()}}</span>
